import { branch, compose, renderNothing, withProps } from 'recompose'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { get } from 'lodash'
import { getInstance } from 'src/vendor/bombBomb'
import { flashNotification } from 'src/actions'
import { forceHistory } from 'src/composables'
import { selectRouteKey } from 'src/store/selectors/layout'
import { PATH_HELPERS } from 'src/constants/navigation'

const enabledRoutes = [PATH_HELPERS.home.regex, PATH_HELPERS.buy.regex]

const isDigestRoute = pathname => enabledRoutes.some(r => r.test(pathname))

const BombBombContainer = compose(
  connect(
    state => {
      const { bombBomb, buyerInfo } = state
      const buyerEmail = buyerInfo.email
      const homeownerEmails = get(state, 'home.data.users', []).map(
        u => u.email
      )

      return {
        bombBomb,
        buyerEmail,
        homeownerEmails,
        videoTitle: `Homebot Buyer - ${buyerInfo.firstName} ${
          buyerInfo.lastName
        } - ${moment().format('M/D/YY')}`,
        toSubject: `A tip about your ${moment()
          .locale('en')
          .format('MMMM')} Homebot report`,
        toBody:
          "The market is changing rapidly. I've outlined a few great opportunities for you here based on your current situation."
      }
    },
    dispatch => ({
      notify: message => dispatch(flashNotification(message))
    })
  ),
  injectIntl,
  withRouter,
  forceHistory,
  branch(
    ({ bombBomb, location, buyerEmail, homeownerEmails }) => {
      const prereqs = [
        bombBomb.initialized,
        isDigestRoute(location.pathname),
        selectRouteKey() === 'home' ? homeownerEmails.length : buyerEmail
      ]

      return !prereqs.every(Boolean)
    },
    renderNothing,
    withProps(props => {
      const { bombBomb, buyerEmail, homeownerEmails } = props
      const toEmail =
        selectRouteKey() === 'home' ? homeownerEmails.join(', ') : buyerEmail

      return {
        bombBomb: getInstance(),
        open: bombBomb.open,
        mount: bombBomb.mount,
        error: bombBomb.error,
        toEmail
      }
    })
  )
)

export default BombBombContainer
